import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useFormikContext } from "formik";
import CommandWidget from "./command-widget";
import { Button } from '../../../components/button/Button';

interface SummaryStepProps {
    onBack: (e) => void;
}

const SummaryStep: FC<SummaryStepProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <span className={`mb-2 text-portal-blue-primary-shade2 text-lg font-semibold`} >
            {translate.byKey(TranslationKeys.summary)}
        </span>
        <CommandWidget widget={values} previewMode={true} />
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <Button
                    variant="submit"
                    shape="pill"
                    id="confirmButton"
                    type="submit">{translate.byKey(TranslationKeys.confirm)}</Button>
            </div>
        </div>
    </div >
}

export default SummaryStep;